import React from 'react';
import { Button } from '../../ui/button';
import { Trash2 } from 'lucide-react';

/**
 * Bulk-action bar shown above the Contacts / Quotes table when any rows are selected.
 *
 * Props:
 *  - count: number of selected rows
 *  - onClear: clear selection callback
 *  - onDelete: bulk-delete callback
 *  - deleting: boolean disables the delete button while in-flight
 *  - testidPrefix: 'contacts' | 'quotes' (drives data-testid)
 */
const BulkActionBar = ({ count, onClear, onDelete, deleting, testidPrefix }) => {
  if (count === 0) return null;
  return (
    <div className="flex items-center justify-between rounded border border-red-900/40 bg-red-950/20 px-3 py-2">
      <span className="text-sm text-red-200" data-testid={`${testidPrefix}-selected-count`}>
        {count} selected
      </span>
      <div className="flex items-center gap-2">
        <Button
          size="sm" variant="outline"
          data-testid={`${testidPrefix}-clear-selection`}
          onClick={onClear}
          className="border-slate-700 text-gray-300 hover:bg-slate-800"
        >
          Clear
        </Button>
        <Button
          size="sm"
          data-testid={`${testidPrefix}-bulk-delete`}
          onClick={onDelete}
          disabled={deleting}
          className="bg-red-600 hover:bg-red-700 text-white"
        >
          <Trash2 className="w-3 h-3 mr-1" />
          {deleting ? 'Deleting…' : `Delete ${count} selected`}
        </Button>
      </div>
    </div>
  );
};

export default BulkActionBar;
